import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Message } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Global Components
import LoadingGate from 'components/LoadingGate';
// @ts-ignore
import ErrorGate from 'components/ErrorGate';

// Local selectors
import { makeSelectTotalBinsForDateAndPeople } from './selectors';

export interface OwnProps {
    entityId?: number;
    startDate?: string;
    endDate?: string;
    personIds?: number[];
}

interface ConnectedProps {
    totalBinsForDateAndPeople: number;
}

type Props = OwnProps & ConnectedProps;

export class HarvestEventInspectionDocumentsMessageComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { totalBinsForDateAndPeople } = this.props;

        return (
            <ErrorGate namespace="HARVEST_EVENT_DOCUMENTS_LOAD">
                <LoadingGate
                    namespace="HARVEST_EVENT_DOCUMENTS_LOAD"
                    LoadingComponent={
                        <Message info fluid>
                            Downloading Bin Checks
                        </Message>
                    }
                >
                    <React.Fragment>
                        {!totalBinsForDateAndPeople && (
                            <Message warning visible fluid>
                                Sorry, we could not find any Bin Checks. When
                                they exist they can be used to auto fill entry
                                data (e.g. count)
                            </Message>
                        )}
                        {totalBinsForDateAndPeople > 0 && (
                            <Message positive fluid>
                                {`Successfully downloaded ${totalBinsForDateAndPeople} Bin Check${
                                    totalBinsForDateAndPeople > 1 ? 's' : ''
                                }. These will be used to auto fill entry data (e.g. count)`}
                            </Message>
                        )}
                    </React.Fragment>
                </LoadingGate>
            </ErrorGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    totalBinsForDateAndPeople: makeSelectTotalBinsForDateAndPeople()
});

export default connect(mapStateToProps)(
    HarvestEventInspectionDocumentsMessageComponent
);
